import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface PasswordFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  id?: string;
  label: string;
  autoComplete?: string;
}

/** Поле пароля с кнопкой показа/скрытия (глаз) */
export const PasswordField: React.FC<PasswordFieldProps> = ({
  value,
  onChange,
  placeholder = '••••••••',
  required,
  id,
  label,
  autoComplete,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputId = id || `password-${Math.random().toString(36).slice(2)}`;

  return (
    <div>
      <label htmlFor={inputId} className="block text-sm font-medium text-stone-800 dark:text-slate-200 mb-1">
        {label}
      </label>
      <div className="relative">
        <input
          id={inputId}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required={required}
          autoComplete={autoComplete}
          className="w-full px-3 py-2.5 pr-12 rounded-xl border border-stone-200 dark:border-slate-500 bg-white/80 dark:bg-slate-700/50 text-stone-900 dark:text-white placeholder-stone-400 dark:placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-400"
        />
        <button
          type="button"
          onClick={() => setShowPassword((v) => !v)}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-lg text-stone-500 dark:text-slate-400 hover:text-stone-700 dark:hover:text-slate-200 hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
          aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
          tabIndex={-1}
        >
          {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;
